import { useMemo } from 'react';
import { useAuthenticatedQuery } from '../useAuthenticatedQuery';
import axios from 'axios';
import { API_BASE_URL, FUNCTION_KEY, PROJECT_SCOPE } from '../../config';
import logError from '../metadata/ErrorLogging';
import PropTypes from 'prop-types';

export default function useEventTypes(event_level) {

  const fetchEventTypes = async (token) => {

    const theParams = {
        event_level: event_level
    };

    try {
        const response = await axios.get(`${API_BASE_URL}event_types`, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'x-functions-key': FUNCTION_KEY
            },
            params: theParams
        });

        return response.data;

    } catch (error) {
      logError('Failed to load event types in useEventTypes', error, theParams); // Error during fetch
      throw error;
    }
  };

  const projectScope = [PROJECT_SCOPE];
  const queryKey = ['event_types', event_level];

  const { data: eventTypes = [], isLoading, refetch, error } = useAuthenticatedQuery(queryKey, fetchEventTypes, projectScope, {
    enabled: !!event_level,
    staleTime: 60 * 60 * 1000,  // Data will be cached for 60 minutes
  });

  // Sort event types alphabetically by title, with 'Other' at the end
  // useMemo is used to prevent sorting on every render - it will only re-sort when eventTypes changes
  const sortedEventTypes = useMemo(() => {
    return [...eventTypes].sort((a, b) => {
      if (a.title === 'Other' && b.title !== 'Other') return 1;
      if (b.title === 'Other' && a.title !== 'Other') return -1;
      return a.title.localeCompare(b.title);
    });
  }, [eventTypes]);

  return { eventTypes: sortedEventTypes, eventTypesLoading: isLoading, refetchEventTypes: refetch, eventTypesError: error };
}

useEventTypes.propTypes = {
  event_level: PropTypes.string.isRequired
};